export default __webpack_public_path__ + "static/media/tj.839f273d.svg";